import React from 'react';
import { Box, Pagination } from 'edenred-ui';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';

import { TODAY } from '@epi-constants/downloadReports';

import { TransactionsCalendarRange } from '../TransactionsCalendarRange';
import { TransactionsSelectRange } from '../TransactionsSelectRange';

import { DepositsTable } from './DepositsTable';
import { useDeposits } from './hooks/useDeposits';

export const Deposits = () => {
  const { t } = useTranslation();
  const { gray10 } = useTheme();
  const {
    deposits,
    page,
    totalPages,
    isLoading,
    showCalendar,
    setShowCalendar,
    timePeriodType,
    handleChangePage,
    from,
    to,
    setFrom,
    setTo,
    setPage,
    setTimePeriodType
  } = useDeposits();

  const closeTimePeriod = () => {
    setShowCalendar(false);
  };

  return (
    <Box marginTop="40px">
      <Box pb={5} borderBottom={`1px solid ${gray10}`} my={5}>
        <TransactionsSelectRange
          setPage={setPage}
          setShowCalendar={setShowCalendar}
          timePeriodType={timePeriodType}
          setTimePeriodType={setTimePeriodType}
          from={from}
          setFrom={setFrom}
          to={to}
          setTo={setTo}
        />
      </Box>
      {showCalendar && (
        <TransactionsCalendarRange
          isOpen={showCalendar}
          closeAction={closeTimePeriod}
          disabledCustomDates={{ after: TODAY }}
          from={from}
          to={to}
          setFrom={setFrom}
          setTo={setTo}
        />
      )}
      <DepositsTable deposits={deposits} isLoading={isLoading} />
      <Box mt={5}>
        <Pagination
          prevBtnText={t('shared.pagination.previous')}
          nextBtnText={t('shared.pagination.next')}
          page={page}
          count={totalPages}
          onChangePage={handleChangePage}
        />
      </Box>
    </Box>
  );
};
